require("dotenv").config(); //eslint-disable-line

const fr = require('./src/data/fr/index');
const en = require('./src/data/en/index');


module.exports = {
  attributes: { //  add html attriutes in the firts node of the application node
    youtube: {
      test: '12345',
    },
    contest: {
      value: '#contest',
    },
  },
  // data fr and en
  fr,
  en,
};
